// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:07:12

export default {
  "id": "kitty-squad-winter-dress-up",
  "slug": "kitty-squad-winter-dress-up",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7a5c4da4640140d9aec06019b86c9916-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7a5c4da4640140d9aec06019b86c9916/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Kitty Squad Winter Dress Up",
      "description": "Step into the adorable world of Kitty Squad Winter Dress Up, where you can style your kitty for the winter season! Choose from cozy outfits, cute accessories, and festive winter gear to create the perfect look for your furry friend. With its charming graphics and endless customization options, this game is perfect for fashion lovers and cat enthusiasts alike. Start dressing up your kitty today! ",
      "instructions": "Left Mouse Button Click Or Tap to Play",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "fashion",
        "girls",
        "girlsdressup",
        "winter"
      ]
    },
    "zh-CN": {
      "title": "猫咪小队冬季装扮",
      "description": "踏入可爱的小猫特工队冬季装扮的世界，在这里你可以为你的猫咪装扮冬季造型！从舒适的服装、可爱的配饰和节日的冬季装备中选择，为你的毛茸茸的朋友打造完美的造型。凭借其迷人的图形和无尽的定制选项，这款游戏非常适合时尚爱好者和猫迷。今天就开始为你的猫咪装扮吧！",
      "instructions": "左鼠标按钮点击或轻触开始游戏",
      "genres": [
        "装扮"
      ],
      "tags": [
        "可爱装扮",
        "时尚",
        "女孩",
        "女孩装扮",
        "冬季"
      ]
    },
    "zh-TW": {
      "title": "貓隊冬季裝扮",
      "description": "進入可愛的Kitty Squad冬日裝扮世界，您可以在這裡為您的貓咪打造冬季造型！從舒適的服裝、可愛的配飾到節慶的冬日裝備，選擇最完美的搭配給您的毛茸茸朋友。擁有迷人的圖像和無限的定制選項，這款遊戲完美適合時尚愛好者和貓咪迷。今天開始為您的貓咪打扮吧！",
      "instructions": "左鍵點擊或輕觸以開始遊戲",
      "genres": [
        "裝扮"
      ],
      "tags": [
        "可愛装扮",
        "時尚",
        "女孩",
        "女孩装扮",
        "冬季"
      ]
    },
    "zh-HK": {
      "title": "貓貓小隊冬日裝扮",
      "description": "進入可愛的Kitty Squad冬日裝扮世界，您可以為貓咪打扮適合冬日裝扮！從舒適的服裝、可愛的配件和節慶冬日裝備中選擇，為您的毛茸茸朋友打造完美造型。這款遊戲擁有迷人的圖像和無限的客製化選項，適合時尚愛好者和貓咪迷。今天開始為您的貓咪打扮吧！",
      "instructions": "左鍵按鈕點擊或觸控以遊戲",
      "genres": [
        "打扮"
      ],
      "tags": [
        "可愛裝飾",
        "時尚",
        "女孩",
        "女孩裝飾",
        "冬日"
      ]
    },
    "ja": {
      "title": "キティスクワッド ウィンタードレスアップ",
      "description": "冬の可愛い世界「Kitty Squad Winter Dress Up」へ入って、あなたの猫を冬に合わせてスタイリングしましょう！快適な洋服、可愛いアクセサリー、そして冬の季節の装備から選んで、あなたの毛むくじゃらの友達のための完璧なスタイルを作りましょう。魅力的なグラフィックと無限のカスタマイズオプションを持つこのゲームは、ファッション好きと猫好きのどちらにも最適です。今すぐあなたの猫のドレスアップを始めましょう！",
      "instructions": "左マウスボタンクリックまたはタップして遊ぶ",
      "genres": [
        "ドレスアップ"
      ],
      "tags": [
        "カワイイドレスアップ",
        "ファッション",
        "ガールズ",
        "ガールズドレスアップ",
        "冬"
      ]
    },
    "ko": {
      "title": "키티 스쿼드 동계 드레스업",
      "description": "사랑스러운 Kitty Squad Winter Dress Up의 세계로 들어가세요! 겨울 시즌을 위해 고양이를 스타일링할 수 있습니다! 편안한 옷차림, 귀여운 액세서리, 겨울 파티 가구를 선택하여 고양이 친구의 완벽한 룩을 만들어보세요. 매력적인 그래픽과 끝없는 테마화 옵션으로, 이 게임은 패션 애호가와 고양이 애호가 모두에게 적합합니다. 지금 고양이의 드레스업을 시작하세요!",
      "instructions": "좌鼠标 버튼 클릭 또는 탭하여 게임 시작",
      "genres": [
        "의상 드레스업"
      ],
      "tags": [
        "쿵따dressup",
        "패션",
        "소녀",
        "소녀dressup",
        "겨울"
      ]
    },
    "fr": {
      "title": "Escorte de Chaton - Déguisement d'Hiver",
      "description": "Plongez dans le charmant monde de Kitty Squad Winter Dress Up, où vous pouvez styliser votre chatte pour la saison hivernale ! Choisissez parmi des tenues confortables, des accessoires mignons et des équipements de Noël pour créer le look parfait pour votre animal de compagnie. Avec ses graphismes charmants et ses options de personnalisation illimitées, ce jeu est parfait pour les amoureux de mode et les passionnés de chats. Commencez à habiller votre chatte aujourd'hui !",
      "instructions": "Clic gauche ou tapoter pour jouer",
      "genres": [
        "Dress-up"
      ],
      "tags": [
        "cutedressup",
        "mode",
        "filles",
        "fillesdressup",
        "hiver"
      ]
    }
  }
};
